import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { useWhoWeAreCommon } from "@/pages-react/who-we-are/WhoWeAreCommon";

export const WhoWeAreMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useWhoWeAreCommon(props.content);

  return <>{renderContent()}</>;
}, LayoutStyleTypes.TYPE_SM);
